import { ContainerOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, Collapse, Empty, Layout, PageHeader, Spin, Table, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { Cache } from '../../../models';
import { apiClient, apiErrorMessage } from '../../../utils';

export function CachesPage() {
  const { Content } = Layout;
  const { Text } = Typography;
  const { Panel } = Collapse;

  const [loading, setLoading] = useState(false);
  const [caches, setCaches] = useState<Cache[]>();

  useEffect(() => {
    loadCaches();
  }, []);

  const loadCaches = () => {
    setLoading(true);
    apiClient
      .get('caches')
      .then(response => {
        setCaches(response.data);
        setLoading(false);
      })
      .catch((reason: any) => {
        setLoading(false);
        apiErrorMessage(reason);
      });
  };

  const onResetClick = (key: string) => {
    setLoading(true);
    apiClient
      .delete(`caches/${key}`)
      .then(() => {
        setLoading(false);
        loadCaches();
      })
      .catch((reason: any) => {
        setLoading(false);
        apiErrorMessage(reason);
      });
  };

  const onRefreshClick = () => {
    loadCaches();
  };

  return (
    <>
      <PageHeader
        title={
          <>
            <ContainerOutlined /> Cache'lenmiş veriler
          </>
        }
        extra={[
          <Button key="refresh" onClick={onRefreshClick} icon={<ReloadOutlined />}>
            Yenile
          </Button>,
        ]}
      />
      <Content>
        <Spin spinning={loading}>
          {(caches?.length || 0) <= 0 && (
            <Empty style={{ marginTop: '1rem' }} description={<Text type="secondary">Cache'lenmiş veri bulunmuyor</Text>} />
          )}
          {(caches?.length || 0) > 0 && (
            <Collapse defaultActiveKey={[]} style={{ marginTop: '1rem' }}>
              {caches?.map(c => {
                const extraContent = (
                  <Button
                    type="link"
                    onClick={(e) => {
                      e.stopPropagation();
                      onResetClick(c.key);
                    }}
                  >
                    <Text type="danger">Sıfırla</Text>
                  </Button>
                );

                return (
                  <Panel header={c.key} key={c.key} extra={extraContent}>
                    <CacheTable cache={c} />
                  </Panel>
                );
              })}
            </Collapse>
          )}
        </Spin>
      </Content>
    </>
  );
}

function CacheTable(props: { cache: Cache }) {
  const [columns, setColumns] = useState<any[]>();

  useEffect(() => {
    if (!props.cache.data?.length) {
      return;
    }

    const keys = Object.keys(props.cache.data[0]);
    const newColumns: any[] = [];

    for (const key of keys) {
      const column = {
        title: key,
        dataIndex: key,
        key: key,
        render: (value: string) => {
          if (Object.prototype.toString.call(value) === '[object String]') {
            return value;
          } else {
            return JSON.stringify(value);
          }
        },
      };

      newColumns.push(column);
    }

    setColumns(newColumns);
  }, [props.cache]);

  return (
    <Table columns={columns} dataSource={props.cache.data} scroll={{ x: '100%' }} pagination={false} />
  );
}
